import React from 'react'; 
import {createContext} from 'react'; 
import { db } from '../Config/Config'

export const OrderContext = createContext(); 

export class OrderContextProvider extends React.Component { 
  
    state = { 
      bookings: []
    };  
   
     componentDidMount() { 
         const prevOrders = this.state.bookings; 

         db.collection('Bookings').onSnapshot(snapshot => { 
          let changes = snapshot.docChanges(); 
          changes.forEach((change) => { 
            if(change.type === "added") {  
               prevOrders.push({  
                    BuyerName: change.doc.data().BuyerName,
                    BuyerEmail: change.doc.data().BuyerEmail,
                    BuyerCell: change.doc.data().BuyerCell,
                    BuyerAddress: change.doc.data().BuyerAddress,
                    BuyerPayment: change.doc.data().BuyerPayment,
                    BuyerQuantity: change.doc.data().BuyerQuantity
               });
            } 
            this.setState({
            bookings: prevOrders});
          })
        })
     }

    render() {  
         
    return( 
        <OrderContext.Provider value={{ bookings: [...this.state.bookings] }}> 
          {this.props.children}
       </OrderContext.Provider> 
       );
    } 

}